module.exports = __webpack_public_path__ + "img/20190723145055QQ截图20190722221517.2fb1938c.png";